/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'demographics';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/demographics/v2/portal
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:DemographicsResourceV2+type:symbol+getPortalDemographics&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Demographics_V2-get-%2Fdemographics%2Fv2%2Fportal'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fdemographics%2Fv2%2Fportal?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getPortalDemographicsRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v2/portal'])
});